import type { AdapterMeta } from "@repo/adapter-core";

export const MARSHALL_WHITE_META: AdapterMeta = {
  slug: "marshall-white",
  name: "Marshall White",
  baseUrl: "https://www.marshallwhite.com.au",
  description: "Luxury real estate agency serving Melbourne's most prestigious suburbs.",
  supportedStates: ["VIC"],
  urlPattern: /marshallwhite\.com\.au\/property\/[a-z0-9-]+\/?$/i,
  sourceType: "agency",
};
